import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { normalizeSupportedLanguage } from '../utils/createScopedI18n';
import { buildScopedI18n } from '../utils/buildScopedI18n';

const tableI18n = buildScopedI18n({
  esCL: {
    emptyMessage: 'No se encontraron resultados para tu búsqueda.',
    showingZeroResultsText: 'Mostrando: 0 - 0 resultados',
    showingResultsPartOne: 'Mostrando:',
    showingResultsPartTwo: 'de',
    showingResultsPartLastSingular: 'resultado',
    showingResultsPartLastPlural: 'resultados',
    rowByPagesText: 'Filas por página:',
  },
  enUS: {
    emptyMessage: 'No results found for your search.',
    showingZeroResultsText: 'Showing: 0 - 0 results',
    showingResultsPartOne: 'Showing:',
    showingResultsPartTwo: 'of',
    showingResultsPartLastSingular: 'result',
    showingResultsPartLastPlural: 'results',
    rowByPagesText: 'Rows per page:',
  },
  ptBR: {
    emptyMessage: 'Nenhum resultado encontrado para sua busca.',
    showingZeroResultsText: 'Exibindo: 0 - 0 resultados',
    showingResultsPartOne: 'Exibindo:',
    showingResultsPartTwo: 'de',
    showingResultsPartLastSingular: 'resultado',
    showingResultsPartLastPlural: 'resultados',
    rowByPagesText: 'Linhas por página:',
  },
});

export const useTableI18nProps = () => {
  const { language } = useLanguage();
  const lang = normalizeSupportedLanguage(language);
  const { t } = useTranslation(undefined, { i18n: tableI18n });

  useEffect(() => {
    tableI18n.changeLanguage(lang);
  }, [lang]);

  return {
    emptyMessage: t('emptyMessage'),
    showingZeroResultsText: t('showingZeroResultsText'),
    showingResultsPartOne: t('showingResultsPartOne'),
    showingResultsPartTwo: t('showingResultsPartTwo'),
    showingResultsPartLastSingular: t('showingResultsPartLastSingular'),
    showingResultsPartLastPlural: t('showingResultsPartLastPlural'),
    rowByPagesText: t('rowByPagesText'),
  };
};
